import LeasedCarList from "../../components/cars/leasedCarList";
import { CardListSkeletion } from "../../components/elements/skeletions";
import { useCallback } from "react";
import { DosumentsSection } from "./components/documentsSection";
import { ServiceHistorySkeletion } from "../../components/elements/skeletions/skeletions";

export const CarDocuments = ({
  carList,
  selectedCar,
  searchTerm,
  handleCardClick,
  isLoading,
  isFetchingNextPage,
  hasNextPage,
  fetchNextPage,
  docs,
  isDocumentsLoading,
}) => {
  const handleScroll = useCallback(
    (e) => {
      const el = e.currentTarget;

      const distanceFromBottom =
        el.scrollHeight - el.scrollTop - el.clientHeight;

      // fetch when user is near the bottom
      if (distanceFromBottom < 120 && hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    },
    [hasNextPage, isFetchingNextPage, fetchNextPage]
  );

  return (
    <div className="flex flex-col gap-4 min-h-[70vh] max-lg:mb-[110px]">
      <div className="grid grid-cols-4 gap-4">
        <ul
          onScroll={handleScroll}
          className="flex flex-col gap-3 overflow-y-auto pe-3 max-h-[70vh] min-h-[70vh] h-fit scrollbar col-span-1"
        >
          {isLoading && !carList?.pages ? (
            <CardListSkeletion />
          ) : (
            <>
              <LeasedCarList
                selectedCar={selectedCar}
                carList={carList}
                searchTerm={searchTerm}
                handleCardClick={handleCardClick}
                isUsedInDocumentsSection
              />
              {isFetchingNextPage && (
                <li className="py-3 text-sm text-[#6A6A6A] text-center list-none">
                  Φόρτωση περισσότερων...
                </li>
              )}
            </>
          )}
        </ul>
        <div className='col-span-3 w-full '>
          {(
            isDocumentsLoading && !!selectedCar 
            ? <ServiceHistorySkeletion /> 
            : <p>{!selectedCar ? "Επίλεξε ένα αμάξι από τη λίστα για να δεις τα έγγραφα που αντιστοιχούν σε αυτό." : docs?.length === 0 && "Δεν υπάρχουν διαθέσιμα έγγραφα σε αυτήν την κατηγορία"}</p>
          )}
          {!!selectedCar && !isDocumentsLoading && <div className='bg-white rounded-xl'>
            {docs?.filter((doc) => ["3f9b3b97-01f9-42c4-85e6-c0619d796d09"].includes(doc?.category))?.length > 0 && <DosumentsSection 
              title={"Συμβατικά Έγγραφα"} 
              documentsList={docs?.filter((doc) => ["3f9b3b97-01f9-42c4-85e6-c0619d796d09"].includes(doc?.category))}
              isDocumentsLoading={isDocumentsLoading}
              selectedCar={selectedCar}
              section={"car"}
              />}
            {docs?.filter((doc) => !["3f9b3b97-01f9-42c4-85e6-c0619d796d09"].includes(doc?.category))?.length > 0 && <DosumentsSection 
              title={"Έγγραφα Αυτοκινήτου"} 
              documentsList={docs?.filter((doc) => !["3f9b3b97-01f9-42c4-85e6-c0619d796d09"].includes(doc?.category))}
              isDocumentsLoading={isDocumentsLoading}
              selectedCar={selectedCar}
              section={"car"}
            />}
          </div>}
        </div>
      </div>
    </div>
  );
};